import { useMutation } from "@tanstack/react-query";
import { validateCoupon, redeemCoupon } from "../infrastructure/coupon.api";
import type { CouponValidationDto } from "../dtos/coupon.dto";

export function useValidateCoupon() {
  return useMutation({
    mutationFn: ({
      code,
      organizationId,
    }: {
      code: string;
      organizationId: string;
    }) => validateCoupon(code, organizationId),
  });
}

export function useRedeemCoupon() {
  return useMutation({
    mutationFn: ({
      code,
      organizationId,
    }: {
      code: string;
      organizationId: string;
    }) => redeemCoupon(code, organizationId),
  });
}

/**
 * Returns a user-friendly summary of the coupon validation result.
 */
export function couponSummary(
  validation: CouponValidationDto | undefined,
): string | null {
  if (!validation?.isValid) return null;
  const parts: string[] = [];
  if (validation.creditAmount > 0)
    parts.push(`R${validation.creditAmount.toFixed(2)} wallet credit`);
  if (validation.trialDurationDays > 0)
    parts.push(`${validation.trialDurationDays}-day trial`);
  return parts.length > 0 ? parts.join(" + ") : null;
}
